import type { TextToSpeechOptions, TextToSpeechResponse } from '~/models/Brikke/TextToSpeech'
import { brikkeClient } from '~/api/client/brikkeClient'

export const useBrikkeApi = () => ({
  textToSpeech: async (options: TextToSpeechOptions): Promise<TextToSpeechResponse> =>
    (await brikkeClient.post<TextToSpeechResponse>('/v1/tts', options)).data,
})
